import styled from 'styled-components';
import { HeadlineLevel } from '../../../atoms/Headline/Headline';
import { CTAIconPosition } from '../../../atoms/CTA/CTA.constants';
import Col from '~/grid/Col';
import { Headline500 } from '../../../atoms/Headline';
import CTA from '../../../atoms/CTA';
import { mq } from '~/styles/grid';

const StyledCol = styled(Col)`
  @media (${mq.mdDown}) {
    display: flex;
    align-items: center;
    margin-top: 50px;
  }

  @media (${mq.smDown}) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const StyledHeadline = styled(Headline500)`
  color: ${(props) => props.theme.color.white500};
  margin-bottom: 25px;
  @media (${mq.mdDown}) {
    margin-bottom: 0;
    width: 50%;
  }
  @media (${mq.smDown}) {
    width: 100%;
  }
`;

const CtaContainer = styled.div`
  @media (${mq.mdDown}) {
    width: 50%;
  }
  @media (${mq.smDown}) {
    width: 100%;
    margin-top: 20px;
  }
`;

/**
 * @param {FooterCtaProps} props
 * @returns {React.ReactElement} The rendered component
 */
const FooterCtaColumn = ({ headline, cta }) => (
  <StyledCol colAmount={{ xl: 3, lg: 4, md: 12, sm: 12, xs: 12 }}>
    <StyledHeadline level={HeadlineLevel.h3}>{headline}</StyledHeadline>
    <CtaContainer>
      <CTA
        skin="PRIMARY"
        icon="ARROW_ANIMATION"
        iconPos={CTAIconPosition.After}
        {...cta}
        isBrand
      />
    </CtaContainer>
  </StyledCol>
);

export default FooterCtaColumn;
